import React, {FunctionComponent, ReactNode} from 'react';
import "./button.scss";
import Anchor from "../Anchor";
import clsx from "clsx";

interface IProps {
    href: string;
    children: ReactNode;
    variation: number;
    className?: string;
}

const Button:FunctionComponent<IProps> = (props) => {
    const {href, className = "", variation = "1", children} = props;

    if (href) {
        return (
            <Anchor {...props} classes={clsx("button", `type${variation}`, className)}>
                {children}
            </Anchor>
        );
    }

    return (
        <button {...props} className={clsx("button", `type${variation}`, className)}>
            {children}
        </button>
    );
}

export default Button;